import { openTelegramProfile } from '../../telegram/links';
import { ru } from '../../strings/ru';
import styles from './Credit.module.css';

/** Автор упомянут один раз, мелко и внизу — приложение не о нём */
export function Credit() {
  return (
    <p className={styles.credit}>
      {ru.credit.by}{' '}
      <button
        className={styles.link}
        onClick={() => openTelegramProfile(ru.credit.username)}
      >
        @{ru.credit.username}
      </button>
    </p>
  );
}
